// removed by extract-text-webpack-plugin
module.exports = {"mask":"_1mXNeS57Ao"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/presentational/AccountNumber/AccountNumber.module.less
// module id = 996
// module chunks = 3